"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlight = void 0;
var react_1 = __importDefault(require("react"));
function Highlight(props) {
    var text = props.text, words = props.words;
    var validWords = words
        .filter(function (w) { return !!w; })
        .map(function (w) { return w.trim(); })
        .filter(function (w) { return !!w; });
    if (validWords.length <= 0) {
        return react_1.default.createElement("span", null, text);
    }
    var regex = new RegExp(validWords.join('|'), 'gi');
    return (react_1.default.createElement("span", { dangerouslySetInnerHTML: {
            __html: text.replace(regex, function (match) {
                return "<mark>" + match + "</mark>";
            }),
        } }));
}
exports.Highlight = Highlight;
//# sourceMappingURL=Highlight.js.map